<template><PageHeader :title="header ? header.title : title" :description="header ? header.description : description" :icon="icon"><template #actions><slot name="actions" /></template><slot /></PageHeader></template>
<script>
import axios from 'axios'
import PageHeader from '@/Shared/PageHeader'
export default {
 components: { PageHeader },
 props: { title: String, description: String, icon: String },
 data: () => ({ header: null }),
 mounted() { axios.get('/licenses/page-header').then(({data}) => {this.header=data.header}).catch(() => { /* Keep the existing page text if settings are unavailable. */ }) },
}
</script>
